
import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useWorkoutTypes } from "@/hooks/useWorkoutTypes";
import { TimeSlotFormData } from "./timeSlotFormSchema";

interface WorkoutTypeSelectionFieldProps {
  control: Control<TimeSlotFormData>;
}

const WorkoutTypeSelectionField: React.FC<WorkoutTypeSelectionFieldProps> = ({ control }) => {
  const { t } = useTranslation();
  const { workoutTypes, loading: workoutTypesLoading } = useWorkoutTypes();

  // Filter only active workout types
  const activeWorkoutTypes = workoutTypes.filter(wt => wt.is_active);

  return (
    <FormField
      control={control}
      name="workoutTypeId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('schedule.workoutType')}</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue 
                  placeholder={
                    workoutTypesLoading 
                      ? t('common.loading')
                      : t('schedule.workoutType')
                  } 
                />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {activeWorkoutTypes.map((workoutType) => (
                <SelectItem key={workoutType.id} value={workoutType.id}>
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: workoutType.color }}
                    />
                    {workoutType.name}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default WorkoutTypeSelectionField;
